angular.module("informazioniImmobile.components", []).component("informazioniImmobile", {
    templateUrl: "ng/components/riscattoAnticipato/firmatarioRiscatto/informazioniImmobile.view.html",
    bindings: {
        richiestePostVendita: "<",
        validateInformazioniImmobile: "&"
    },
    controllerAs: "informazioniImmobileCtrl",
    controller: function informazioniImmobile(
        $RichiestePostVenditaService,
        $searchUserService,
        $userService,
        $modalService,
        Pf,
        $timeout
    ) {
        var self = this;

        self.$onInit = function () {
            self.mapInfo = "";

            self.supportModel = {
                permessoEdilizio: undefined,
                dataConcessioneEdilizia: undefined,
                isCondo: null,
                isSublocTerzi: null
            }

        }

        self.fieldChanges = function (property, value) {
            if (property === "date") {
                self.supportModel.dataConcessioneEdilizia = value;
            }
            self.validateComponent();
        }

        self.validateComponent = function () {
            if (self.supportModel.permessoEdilizio && self.supportModel.dataConcessioneEdilizia && (self.supportModel.isCondo != null) && (self.supportModel.isSublocTerzi != null)) {
                self.richiestePostVendita.metadata.riscattoAnticipato.infoImmobile = self.supportModel;
                self.validateInformazioniImmobile({
                    validity: true
                });
            } else {
                self.validateInformazioniImmobile({
                    validity: false
                });
            }
        }
    }
})